import { Dialog, DialogContent } from '@mui/material';

import DialogTitleWithCloseButton from '~/components/DialogTitleWithCloseButton';
import type { InvoiceViewerDocument } from '~/components/invoices/detailPage/invoiceDocuments';
import { InvoiceDocumentViewer } from '~/components/invoices/detailPage/InvoiceDocumentViewer';

interface InvoiceDocumentDialogProps {
  open: boolean;
  onClose: () => void;
  primaryDocuments: InvoiceViewerDocument[];
  supportingDocuments: InvoiceViewerDocument[];
  isLoading: boolean;
  title: string;
  emptyMessage?: string;
}

/**
 * The invoice's document, full-height in a dialog rather than a side pane: it is
 * consulted in bursts, and a permanent pane taxed every other task on the page with the
 * width it held.
 */
export function InvoiceDocumentDialog({
  open,
  onClose,
  primaryDocuments,
  supportingDocuments,
  isLoading,
  title,
  emptyMessage,
}: InvoiceDocumentDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      // A right-hand detail surface needn't lock background scroll, and locking it
      // leaves a stuck overflow gutter if the dialog is torn down mid-transition.
      disableScrollLock
      slotProps={{ paper: { sx: { height: '92vh' } } }}
    >
      <DialogTitleWithCloseButton onClose={onClose} title={title} />
      <DialogContent sx={{ p: 0, display: 'flex', minHeight: 0 }}>
        <InvoiceDocumentViewer
          primaryDocuments={primaryDocuments}
          supportingDocuments={supportingDocuments}
          isLoading={isLoading}
          emptyMessage={emptyMessage}
          sx={{ flex: 1, minHeight: 0 }}
        />
      </DialogContent>
    </Dialog>
  );
}
